





























import { Skill } from '@/store/types.ts';

export default {
  name: 'Home',
  components: {},
  data: () => {
    return {};
  },
  props: {
    title: {
      type: String
    },
    skills: Array as () => Array<Skill>
  },
  computed: {},
  methods: {}
};
